<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    title="管理清关行"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <div class="opt">
        <el-button type="primary" @click="add">新增行</el-button>
      </div>
      <BaseTable
        :height="500"
        :tableData="tableData"
        :isPager="false"
        :loading="false"
      >
        <template slot="opt" slot-scope="row">
          <template v-if="row.scope.isEdit">
            <el-button
              type="text"
              @click="save(row.scope)"
            >确定</el-button
            >
            <el-button type="text" @click="getList()">取消</el-button>
          </template>
          <template v-else>
            <el-button
              type="text"
              @click="row.scope.isEdit = true"
            >编辑</el-button
            >
            <el-button type="text" @click="handleDelete(row.scope)">删除</el-button>
          </template>
        </template>
        <template slot="code" slot-scope="row">
          <el-input
            v-if="!row.scope.id && row.scope.isEdit"
            v-model="row.scope.code"
            placeholder="请输入代码"
          ></el-input>
          <span v-else>
            {{ row.scope.code }}
          </span>
        </template>
        <template slot="receiver" slot-scope="row">
          <el-input
            v-if="row.scope.isEdit"
            v-model="row.scope.receiver"
            placeholder="请输入收件人"
          ></el-input>
          <span v-else>
            {{ row.scope.receiver }}
          </span>
        </template>
        <template slot="cc" slot-scope="row">
          <el-input
            v-if="row.scope.isEdit"
            v-model="row.scope.cc"
            placeholder="请输入抄送"
          ></el-input>
          <span v-else>
            {{ row.scope.cc }}
          </span>
        </template>
        <template slot="replyTo" slot-scope="row">
          <el-input
            v-if="row.scope.isEdit"
            v-model="row.scope.replyTo"
            placeholder="请输入接收回复邮箱"
          ></el-input>
          <span v-else>
            {{ row.scope.replyTo }}
          </span>
        </template>
      </BaseTable>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
const BaseTable = () => import('@/components/table/BaseTable')
import {
  addSupTemplate,
  modifySupTemplate,
  supTemplateList,
  deleteSupTemplate
 } from '@/api/bill'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'code',
            label: '清关行代码',
            width: '100',
            isCustom: true
          },
          {
            filed: 'receiver',
            label: '收件人',
            width: '',
            isCustom: true
          },
          {
            filed: 'cc',
            label: '抄送',
            width: '',
            isCustom: true
          },
          {
            filed: 'replyTo',
            label: '接收回复邮箱',
            width: '',
            isCustom: true
          },
          {
            filed: 'opt',
            label: '操作',
            width: '120',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.tableData.columns = this.options.map((item) => {
          return {
            ...item,
            isEdit: false
          }
        })
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok() {
        this.$emit('ok')
    },
    async save(row) {
        const { receiver, cc, replyTo } = this
        if (!receiver) {
            this.$message.error('请选择收件人')
            return
        }
        if (receiver) {
            const item = receiver.split(';')
            const flag = item.some(item => {
                return item.indexOf('@') === -1
            })
            if (flag) {
                this.$message.error('收件人邮箱格式错误')
                return
            }
        }
        if (cc) {
            const item = cc.split(';')
            const flag = item.some(item => {
                return item.indexOf('@') === -1
            })
            if (flag) {
                this.$message.error('抄送人邮箱格式错误')
                return
            }
        }
        if (replyTo) {
            const item = replyTo.split(';')
            const flag = item.some(item => {
                return item.indexOf('@') === -1
            })
            if (flag) {
                this.$message.error('接收回复邮箱格式错误')
                return
            }
        }
            try {
                let res
                this.loading = true
                if (row.id) {
                    res = await modifySupTemplate(row)
                } else {
                    res = await addSupTemplate(row)
                }
                if (res.success) {
                    this.$message.success('添加成功')
                    this.getList()
                } else {
                    this.$message.error(res.errorMessage)
                }
            } catch (error) {
                console.log(error)
            }
    },
    async getList() {
      try {
        const res = await supTemplateList()
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data.map((item, i) => {
            return {
                ...item,
                id: i + 1,
                isEdit: false
            }
          })
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleDelete(row) {
              this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      }).then(() => {
        deleteSupTemplate({
          code: row.code
        }).then((res) => {
          if (res.success) {
            this.$message.success('取消成功')
            this.getList()
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      })
    },
    add() {
        this.tableData.columns.push({
          code: '',
          cc: '',
          receiver: '',
          replyTo: 'service@ankeysc.com',
          isEdit: true
        })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 auto;
  .opt {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
